if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        // Product pages use the custom main-product-adn layout, which has no
        // <product-info> element for this pop-up to load, so "Choose options"
        // did nothing. Send shoppers straight to the product page instead.
        const url = opener && opener.getAttribute('data-product-url');
        if (url) window.location.href = url;
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        ['pickup-availability', 'product-modal', '.product-popup-modal__opener'].forEach((sel) => {
          const el = productElement.querySelector(sel);
          if (el) el.remove();
        });
        ['modal-dialog', 'h1', '.accordion', '.product-description-static', '.product-text-clamp-toggle', '.product-info-tabs', '.product-breadcrumb-block', '.product__cross-links', '.product-share-component', '.main-product--badge', '.product-feature-icon-grid--wrapper'].forEach((sel) => {
          productElement.querySelectorAll(sel).forEach((el) => el.remove());
        });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;
        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });
        productElement.dataset.originalSection = sectionId;
      }
    }
  );
}
